'use client';

import Image, { StaticImageData } from 'next/image';
import Link from 'next/link';

import {
    Align,
    Button,
    ButtonVariant,
    Column,
    Columns,
    Container,
    Spacer,
    SpacerSize,
    Text,
    Title,
    TitleLevels,
} from '@bytel/trilogy-react';

import noProductImage from '@assets/no-product.png';

type ErrorProps = {
    text: string;
    link: string;
    image?: string | StaticImageData;
};

export function ErrorBlock({ link, text, image = noProductImage }: Readonly<ErrorProps>) {
    return (
        <Container>
            <Columns className='has-text-centered'>
                <Column verticalAlign={Align.CENTER}>
                    <Spacer size={SpacerSize.SIX} />
                    <Image src={image} alt='' />
                    <Spacer size={SpacerSize.THREE} />
                    <Title level={TitleLevels.FOUR}>Une erreur s&apos;est produite</Title>
                    <Text>Nous sommes désolé</Text>
                    <Button href={link} routerLink={Link} variant={ButtonVariant.CONVERSION}>
                        {text}
                    </Button>
                </Column>
            </Columns>
        </Container>
    );
}
